<template> 
	<section class="blockElement fix-mt">
		
		<div class="sessionexpriedouter" v-if="sessionexpired">
			 <!-- <div class="cbox">
				<div class="mb-3">
					<img src="../../../static/fxView/images/session_expired.png" alt="session expired" width="200">
				</div>
				<p class="mb-3">Your session has expired. Please login again</p>
				<a role="menuitem" class="prism_btn btn_sm" tabindex="-1" href="#" @click="logout()">{{$t('Okay')}} </a>
			</div>  --> 
		</div>
		

		<!-- <div class="customFlex-wrapper" v-if="$route.path == '/step1' || $route.path == '/step2' || $route.path == '/step3' || $route.path == '/step4' || $route.path == '/step5'">
			<router-view />
		</div> -->

		<div v-if="$route.path == '/step1' || $route.path == '/step2' || $route.path == '/step3' || $route.path == '/step4' || $route.path == '/step5' || $route.path == '/create_live_account' || $route.path == '/choose-account'">
			<router-view />
		</div>

		<div class="customFlex-wrapper" :class="[{'activeMenu':mobmenu}]" v-else>
			<app-left-navbar :classMobileResponsive="classMobileResponsive" v-if="$route.path != $env_var.downloadPlatformLink1.MT4.webTraderInternalLink && $route.path != '/web-trade-link' && $route.path !='/step-one' && $route.path !='/step-two' && $route.path !='/step-three' && $route.path != '/choose-account'"></app-left-navbar>
			<div class=" rightArea dashboard vh_100 whiteBG" :class="($route.path == '/web-trade-link' || $route.path == $env_var.downloadPlatformLink1.MT4.webTraderInternalLink)?'Webtradercontainer' : ''">
				<app-header 
					:show_tab="show_header_tab" 
					v-if="$route.path !='/step-one' && $route.path !='/step-two' && $route.path !='/step-three' && $route.path !='/step-four' && $route.path !='/step-five' && $route.path !='/choose-account'">
				</app-header>
				<div class="scrollbar  mainContent" :class="($route.path == '/index' || $route.path == '/notification'  || $route.path == '/two-fa' || $route.path == '/change-password' || $route.path == '/profile' || $route.path == '/create-demo-account' || $route.path == '/create-live-account' || $route.path == '/create-zulu-account' || $route.path == '/create-ib-mamm-pamm-account' || $route.path == '/download-platform' || $route.path == '/minor/failed' || $route.path == '/view'  || $route.path == '/tools' || $route.path == '/subscription-detail' || $route.path == '/transaction-history' || $route.path == '/tools/Economic-Calendar' || $route.path == '/tools/Overview' || $route.path == '/tools/Signals' || $route.path == '/tools/Trading-Hours' || $route.path == '/tools/Calculators' || $route.path == '/tools/Trader-Market-Place' || $route.path == '/tools/Trader-Tool-Box' || $route.path == '/tools/VPS' || $route.path == '/tools/AutoChartist-Scanner')? 'hideSpacing' : '' ">	
					<div class="mainContentOuter container" :class="($route.path == '/view')?'viewContainer':''" id="mainContentOuter">
						<router-view />
					</div>
				</div>
			</div>
		</div>

	</section> 
</template> 

<script>
	import * as types from '../../types'
	import { mapActions } from 'vuex'
	import Header from './shared/header'
	import leftNavbar from './shared/left_navbar'
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import i18n from '@/plugins/lang/i18n';
	import { ProviderCacheMixins } from '@/plugins/vue-provider-cache/mixin'
	export default {
		name: 'FXVIEW',
		mixins: [fxViewMixins/*,ProviderCacheMixins*/],
		data () { 
			return {
				response_msg : '',
                msg_type : '',
				show_header_tab : '',
				classMobileResponsive : false,
				pageLoader : false,
				demoAcountDeposit : false,
				sessionexpired : false,
				
				submitted : false,
				mobmenu : false,
				otp : '',
			}
		},
		components: {
			appHeader: Header,
			appLeftNavbar: leftNavbar
		},
		methods:{
			...mapActions({
				_runUserLogout: types.RUN_USER_LOGOUT,
				_runVerifyLeadOtp: types.RUN_VERIFY_LEAD_OTP,
				_runUserSignUp: types.RUN_USER_SIGNUP,
				_runRefreshData: types.RUN_STATE_LOAD,
			}),
			getAllCurrencyFunc(){
				this._runGetAllCurrencyList({'globalParams' :{},'localParams' :{ "parameter" : this , 'loaderFuncRun' : this.loaderFuncRun}})
			},
			resend(){
                /*const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(this.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');*/
                let input_json={
					'globalParams' :{
						//"email": this.email,
						//"mobile": this.numberWithCountry,
						//"password" : hashedstr,
                        //"captchaToken":this.captchaToken,
                        //"IBREFERLINK":this.IBREFERLINK
					},
					'localParams' :{ "parameter" : this , 'page' : 'resend'}
				}
				this._runUserSignUp(input_json)
            },
			verify_lead(){
                /*const _that = this
                _that.submitted = true;

                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');*/

                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                //"email": _that.email,
                                //"mobile": _that.numberWithCountry,
                                //"password" : hashedstr,
                                "OTP": _that.otp,
                                //"ID": _that.insertId,
                                //"IBREFERLINK":_that.IBREFERLINK
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runVerifyLeadOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
			logout(){
				const _that = this
				let input_json={
					'globalParams' :{},
					'localParams' :{
						"parameter" : _that
					}
				}
				_that._runUserLogout(input_json)
			},
			changeLocale(locale) {
                i18n.locale = locale;    
            }
			
		},
		mounted: function () {
		  	const _that = this
			window.addEventListener('storage', (e) => {
				//console.log("e", e)
			  	if(localStorage.getItem('unauthFlag') && localStorage.getItem('unauthFlag') == "true"){
					_that.sessionexpired = true
					_that.logout()
				}else{
					_that.sessionexpired = false
				}    
			});
			

		},
		created(){
			const _that = this

			this.getAllCurrencyFunc();
			// let demoLiveAccounts = this.get_user.profile.account.filter(acc => parseInt(acc.demo_live) == 1);
			if(localStorage.getItem('unauthFlag') && localStorage.getItem('unauthFlag') == "true"){
				_that.sessionexpired = true
				_that.logout()
			}else{
				_that.sessionexpired = false
			}
			this._runRefreshData({'globalParams' :{},'localParams' :{ "parameter" : this}})

			// this._runGetUserProfile({'globalParams' :{},'localParams' :{ "parameter" : this , 'loaderFuncRun' : 1}})

			this._runGetCountriesList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
			this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
			// this._runUserNotification({'globalParams' :{},'localParams' :{"parameter" : this }})
			this._runGetTicketReasonList({ 'globalParams' :{ },'localParams' :{"parameter" : this }})
			this._runGetWalletBalance({'globalParams' : {},'localParams' : {'parameter' : this}})
			//this._runGetNotificationList({ 'globalParams' :{read : 0}, 'localParams' :{ "parameter" : this } })

			this._runGetLoyalityCardDetail({'globalParams' : {},'localParams' : {'parameter' : this}})
			// {{this.get_user}}
			// console.log(demoLiveAccounts[0].demo_live, "demoLiveAccounts")
			if(localStorage.getItem('lang') && this.get_user.lang != localStorage.getItem('lang')){
				this._runLanguageApi({ 'globalParams' :{ 'lang' : localStorage.getItem('lang') },'localParams' :{"parameter" : this  ,'page' : 'left-bar'}})
			}
			
		},
		
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/index.vue